<script>
import { mapState } from 'vuex'
import { TweenLite, Power2 } from 'gsap/TweenMax'
require('gsap/ScrollToPlugin')

export default {
  name: 'my-scroll',
  render: function (createElement) {
    const tag = this.id === 0 ? 'button' : 'a'
    return createElement(
      tag, {
        on: {
          click: this.myScrollTo
        }
      },
      this.$slots.default
    )
  },
  data () {
    return {
      id: 0
    }
  },
  computed: {
    ...mapState(['headHeight'])
  },
  methods: {
    myScrollTo (e) {
      e.preventDefault()

      TweenLite.to(window, 0.5, {
        ease: Power2.easeOut,
        scrollTo: {
          y: this.id,
          autoKill: false,
          offsetY: this.headHeight
        }
      })
    }
  },
  mounted () {
    this.id = this.$el.getAttribute('href') || 0
  }
}
</script>



// WEBPACK FOOTER //
// src/components/objects/MyScroll.vue